import { isDatasetStorageBackend, type DatasetStorageBackend } from "@/api/datasetStorageBackend";

// 저장 위치 게이트의 순수 로직. URL 토큰 왕복만 다룬다. React 결합부는 이 파일을 사용만 한다
// (`folder/folderTree.ts` 와 같은 방식).
//
// 게이트는 목록을 저장 위치 하나로 좁힌다. 폴더처럼 URL 이 소유한다. 그래야 보던 범위를 링크로
// 그대로 전달할 수 있다. null 은 전체다(게이트 없음).

export const storageBackendSearchParamKey = "storage_backend";

/**
 * URL `?storage_backend=` 토큰을 게이트 값으로 읽는다. 모르는 값은 전체(null)로 바꾼다.
 *
 * URL 은 외부 입력이라 어떤 문자열이든 들어올 수 있다. 서버는 정의되지 않은 값을 422 로 거절한다.
 * 그래서 화면이 먼저 버린다.
 */
export function storageBackendFromParam(raw: string | null): DatasetStorageBackend | null {
  return isDatasetStorageBackend(raw) ? raw : null;
}

/**
 * `?storage_backend=` 를 query string 에 기록한다. 전체면 키를 뺀다.
 *
 * 값이 바뀌면 `page` 를 함께 지운다. 좁힌 뒤에 이전 페이지 번호가 남으면, 결과가 그보다 짧을 때 빈
 * 화면이 나온다(폴더·탭 전환과 같은 규칙).
 *
 * @param params 현재 query string. 변형하지 않는다.
 * @param backend 새 게이트 값. null 은 전체다.
 * @param pageKey 함께 지울 page 키.
 * @returns 새 query string.
 */
export function writeStorageBackendParam(
  params: URLSearchParams,
  backend: DatasetStorageBackend | null,
  pageKey = "page",
): URLSearchParams {
  const next = new URLSearchParams(params);
  if (backend === null) {
    next.delete(storageBackendSearchParamKey);
  } else {
    next.set(storageBackendSearchParamKey, backend);
  }
  next.delete(pageKey);
  return next;
}
